import styled from 'styled-components';

export const ContentWrapper = styled.div`
	width: 100vw;

	background-color: ${({ theme }) => theme.colors.whitePearl} @media screen and
		(max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 0;
	}
`;

export const BackButtonContainer = styled.div`
	cursor: pointer;
	padding-top: 12px;
	padding-left: 12px;
	align-self: flex-start;
`;

export const Padding = styled.div`
	padding-left: 6%;
	padding-right: 3%;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 3%;
	}
`;

export const ContainerTabs = styled(Padding)<{ isPunchup?: boolean }>`
	padding-bottom: 15px;
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.whitePearl : theme.colors.black)};

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 0;
	}
`;

export const AnalyticsContainer = styled(Padding)<{ isPunchup?: boolean }>`
	padding-top: 32px;
	padding-bottom: 15px;
	background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.whitePearl : theme.colors.black)};
	margin-bottom: 32px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 0 24px;
	}
`;

export const Root = styled(ContainerTabs)`
	display: flex;
	justify-content: center;
	flex-direction: column;
	border-radius: 0px;
`;

export const ContainerTabsPieCharts = styled.div`
	display: flex;
	background-color : ${({ theme }) => theme.colors.whitePearl}
	flex-direction: row;
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		flex-direction: column;
	}
`;

export const Divider = styled('div')`
	border: 1px solid ${({ theme }) => theme.colors.lightGrey5};
	width: 100%;
	margin-top: 32px;
	margin-bottom: 22px;
`;

export const SummaryCardsContainer = styled.div`
	display: flex;
	flex-direction: row;
	overflow-x: auto;
	overflow-y: hidden;
	justify-content: space-around;
	width: 100%;
	padding: 15px;
	padding-left: 85px;
	padding-right: 25px;
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		justify-content: flex-start;
	}
`;

export const SmallTicketsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	width: 100%;
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		grid-template-columns: 1fr;
	}
`;

export const Title = styled.div`
	font-family: ${({ theme }) => theme.fonts.primary};
	font-size: 24px;
	line-height: 36px;
	margin-left: 23px;
	margin-top: 19px;
`;
